/* eslint-disable no-unused-vars */
import React from 'react'
import PrimeBtn from './../../components/button/PrimeBtn';
import SecondBtn from './../../components/button/SecondBtn';
import Card from '../../components/main-card/Card';
// import Nav from '../../components/navbar/Nav';
// import Details from '../details/Details';
const Home = () => {
  return (
    <>
      <Card />
    </>
  )
}

export default Home
